import { useState } from "react";
import {
  Autocomplete,
  Button,
  DatePicker,
  Grid,
  TextField,
} from "../../../../components";
import {
  BancosCaixasService,
  BoletoService,
  CaixaService,
  ContasReceberService,
  PessoaService,
  PlugBoletoService,
  SessionService,
  notification,
} from "../../../../services";
import { formatDate, responseErros } from "../../../../utils";
import { InputErros, selecaoTitulosLote } from "../../../../helpers";
import ResumoTotalContas from "./resumo-total-contas.component";
import RenegociacaoTitulosDialog from "./renegociacao-titulos-dialog.component";
import {
  montaListaContasABaixar,
  montaListaRenegociacoes,
} from "../list-contas-receber";
import listaContasReceberValidator from "../middlewares/list-contas-receber.validator";
import { useImportContext } from "../../../../contexts/import.context";
import AddInfoBoletoDialog from "./add-info-boleto.component";
import {
  BoletoApiEntity,
  BoletoEntity,
} from "../../add-contas-receber/entities";
import { statusInvalidosRenegociacao } from "../../resources/constantes";

const RenegociacaoTitulos = ({
  renderRenegociacaoTitulos,
  setRenderRenegociacaoTitulos,
  renegociacaoTitulos,
  setRenegociacaoTitulos,
  calculaTotalAReceber,
  buscarContasReceber,
  listaCondicoesPagamento,
  listaContasReceber,
  setListaContasReceber,
  listaPessoas,
  totalAReceber,
  retornoTopo,
  setLoading,
  setLinhasSelecionadas,
  setTotalAReceber,
  listaMeiosPagamento,
  jurosMultaEmpresas,
}) => {
  const contasReceberService = new ContasReceberService();
  const caixaService = new CaixaService();
  const bancoCaixaService = new BancosCaixasService();
  const boletoService = new BoletoService();
  const pessoaService = new PessoaService();
  const apiBoletoService = new PlugBoletoService();
  const sessionService = new SessionService();
  const { openCollapse } = useImportContext();
  const [meioPagamento, setMeioPagamento] = useState(null);
  const [condicaoPagamento, setCondicaoPagamento] = useState(null);
  const [listaMeiosCondicao, setListaMeiosCondicao] = useState([]);
  const [listaRenegociacoes, setListaRenegociacoes] = useState([]);
  const [pagadoresIguais, setPagadoresIguais] = useState(false);
  const [pagadorList, setPagadorList] = useState([]);
  const [pagadorId, setPagadorId] = useState(null);
  const [openDialogRenegociacao, setOpenDialogRenegociacao] = useState(false);
  const [openDialogInfoBoleto, setOpenDialogInfoBoleto] = useState(false);
  const [cliente, setCliente] = useState(null);
  const [contaBancaria, setContaBancaria] = useState(null);
  const [contasReceber, setContasReceber] = useState([]);
  const [enderecos, setEnderecos] = useState([]);
  const [convenios, setConvenios] = useState([]);

  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const dadosEmpresa = sessionService.getEmpresa();
  const insertUserId = sessionService.getUsuario().id;
  const listaContasReceberValidatorService =
    listaContasReceberValidator(meioPagamento);

  const cadastrarCaixa = async (bancoCaixaId) => {
    const body = {
      data: new Date(),
      bancoCaixaId,
      aberto: true,
    };
    const result = await caixaService.cadastrar(body);
    if (result.isAxiosError) {
      responseErros(result);
      return false;
    }
    return true;
  };

  const buscarBancoCaixa = async () => {
    const result = await bancoCaixaService.getById(meioPagamento?.bancoCaixaId);
    if (!result.isAxiosError) {
      return result.data;
    } else {
      responseErros(result);
      return null;
    }
  };

  const buscarCliente = async () => {
    const result = await pessoaService.getById(pagadorId);
    if (!result.isAxiosError) {
      return result.data;
    } else {
      responseErros(result);
      return null;
    }
  };

  const handleSubmit = async (event, listaRenegociacoes) => {
    event.preventDefault();
    setLoading(true);
    const body = listaRenegociacoes.map((conta) => {
      return { ...conta, pagadorId };
    });
    if (!listaContasReceber.length) return erroBaixa();
    const caixaCadastrado = await cadastrarCaixa(meioPagamento?.bancoCaixaId);
    if (!caixaCadastrado) {
      return;
    }
    if (body?.length) {
      listaContasReceberValidatorService
        .validate(body, { abortEarly: false })
        .then(async () => {
          const res = await contasReceberService.cadastrarLista(body);
          setLoading(false);
          if (!res.isAxiosError) {
            salvarContasReceber(res.data);
          } else {
            responseErros(res);
          }
        })
        .catch((err) => {
          sairRenegociacaoTitulos();
          inputErros.set(err);
        });
    }
  };

  const salvarContasReceber = async (contasCadastradas) => {
    const listaContasABaixar = montaListaContasABaixar(
      listaContasReceber,
      meioPagamento,
      renegociacaoTitulos,
      jurosMultaEmpresas,
      true,
    );
    if (listaContasReceber?.length) {
      listaContasReceberValidatorService
        .validate(listaContasABaixar, { abortEarly: false })
        .then(async () => {
          const res = await contasReceberService.baixaEmLote(
            listaContasABaixar,
          );
          if (!res.isAxiosError) {
            notification.sucessoGenericos(
              "Renegociação realizada com sucesso!",
            );
            if (meioPagamento?.gerarBoleto) {
              const cliente = await buscarCliente();
              if (!cliente) return;
              const bancoCaixa = await buscarBancoCaixa();
              if (!bancoCaixa) return;

              if (
                bancoCaixa?.convenios?.length === 1 &&
                cliente?.enderecos?.length === 1
              ) {
                await gerarBoletos(
                  contasCadastradas,
                  cliente,
                  cliente?.enderecos[0],
                  bancoCaixa,
                  bancoCaixa?.convenios[0],
                );
              } else {
                setCliente(cliente);
                setEnderecos(cliente?.enderecos ?? []);
                setContaBancaria(bancoCaixa);
                setConvenios(bancoCaixa?.convenios ?? []);
                setContasReceber(contasCadastradas);
                setOpenDialogInfoBoleto(true);
              }
            } else {
              sairRenegociacaoTitulos();
              buscarContasReceber();
            }
          } else {
            responseErros(res);
          }
        })
        .catch((err) => {
          sairRenegociacaoTitulos();
          inputErros.set(err);
        });
    } else {
      erroBaixa();
    }
  };

  const gerarBoletos = async (
    contasReceber,
    cliente,
    endereco,
    contaBancaria,
    convenio,
  ) => {
    const apiBody = [];
    const boletos = contasReceber.map((conta, index) => {
      const nossoNumero = Number(convenio.nossoNumeroInicial) + index;
      const convenioTemp = {
        ...convenio,
        nossoNumeroInicial: String(nossoNumero),
      };
      const boletoApi = new BoletoApiEntity(
        conta,
        cliente,
        endereco,
        contaBancaria,
        convenioTemp,
      );
      apiBody.push(boletoApi);
      return {
        ...conta,
        convenioId: convenioTemp.id,
        nossoNumero: String(nossoNumero),
        numeroConvenio: convenioTemp.numero,
      };
    });

    const apiResponse = await apiBoletoService.incluirBoletosLote(
      apiBody,
      dadosEmpresa.cnpjCpf,
    );
    const boletosParaCadastro = [];
    let validacaoErro = false;
    if (apiResponse._dados?._sucesso?.length) {
      boletosParaCadastro.push(...apiResponse._dados._sucesso);
    }

    const bodyCadastro = boletos.map((boleto) => {
      const boletoApi = boletosParaCadastro.find(
        (b) =>
          boleto.nossoNumero === b.TituloNossoNumero &&
          boleto.numeroConvenio === b.CedenteConvenioNumero,
      );
      let erros = null;
      if (!boletoApi) {
        validacaoErro = true;
        const erroApi = apiResponse._dados?._falha?.find(
          (f) =>
            boleto.nossoNumero === f._dados?.TituloNossoNumero &&
            boleto.numeroConvenio === f._dados?.CedenteConvenioNumero,
        )?._erro;
        erros = erroApi?.erros ? Object.values(erroApi.erros).join(";") : null;
      }
      return new BoletoEntity(boletoApi, boleto, convenio, cliente.id, erros);
    });
    const res = await boletoService.cadastrarLote(bodyCadastro);
    if (res.isAxiosError) {
      responseErros(res);
    }

    if (validacaoErro) {
      notification.alertaGenericos(
        "Houve erro ao incluir boletos no sistema. Favor verificar status na aba de Boletos",
      );
    } else {
      notification.sucessoGenericos("Emissão de boletos realizada com sucesso");
    }
    sairRenegociacaoTitulos();
    buscarContasReceber();
  };

  const handleOpenRenegociacao = async () => {
    if (!listaContasReceber.length) return erroBaixa();
    const contasComBoletoValido = listaContasReceber.filter(
      (conta) => conta.boleto && !statusInvalidosRenegociacao.includes(conta.boleto.status),
    );
    if (contasComBoletoValido.length) {
      notification.alertaGenericos(
        "Não é possível renegociar títulos com boletos válidos. Favor cancelar os boletos antes de prosseguir com a renegociação.");
      return;
    }
    if (listaContasReceber.length > selecaoTitulosLote.limiteTitulos) {
      return notification.alertaGenericos(
        selecaoTitulosLote.mensagemLimite(listaContasReceber.length)
      );
    }
    const body = montaListaRenegociacoes(
      listaContasReceber,
      renegociacaoTitulos,
      meioPagamento,
      condicaoPagamento,
      totalAReceber,
      insertUserId,
    );
    if (body.pagadores?.length) {
      const pagadoresIguais = body.pagadores.every((id) => {
        return id === body.pagadores[0];
      });
      if (!pagadoresIguais) {
        const pagadoresList = listaPessoas.filter((pessoa) =>
          body.pagadores.includes(pessoa.id),
        );
        setPagadorList(pagadoresList);
      } else {
        setPagadorList(listaPessoas);
        setPagadorId(body.pagadores[0]);
      }
      setPagadoresIguais(pagadoresIguais);
    }
    setListaRenegociacoes(body.lista);
    setOpenDialogRenegociacao(true);
  };

  function erroBaixa() {
    sairRenegociacaoTitulos();
    return notification.alertaGenericos(
      "Selecione no mínimo uma conta a baixar",
    );
  }

  function sairRenegociacaoTitulos() {
    setLinhasSelecionadas([]);
    setTotalAReceber({
      multa: 0,
      juros: 0,
      subtotal: 0,
      receber: 0,
    });
    setRenderRenegociacaoTitulos(false);
    setOpenDialogRenegociacao(false);
    setCondicaoPagamento(null);
    setMeioPagamento(null);
    setRenegociacaoTitulos({});
    setListaContasReceber([]);
    setPagadorId(null);
    setPagadorList(listaPessoas);
    retornoTopo();
  }

  const onDateChange = (date, fieldName) => {
    if (!date) {
      date = "Invalid Date";
    }
    const renegociacaoTemp = {
      ...renegociacaoTitulos,
      [fieldName]: date != "Invalid Date" ? formatDate.toSend(date) : null,
    };
    setRenegociacaoTitulos(renegociacaoTemp);
    calculaTotalAReceber(listaContasReceber, date);
  };

  const onChangeMeioPagamento = (value) => {
    const listaCondicoes = listaCondicoesPagamento.filter((condicao) =>
      condicao.meiosPagamentos.some((meio) => meio.id === value?.id),
    );
    setListaMeiosCondicao(listaCondicoes);
    setCondicaoPagamento(listaCondicoes[0]);
    setRenegociacaoTitulos({
      ...renegociacaoTitulos,
      quantidadeParcelas: listaCondicoes[0]?.parcelas,
    });
    setMeioPagamento(value);
  };

  const onChangeCondicao = (value) => {
    setRenegociacaoTitulos({
      ...renegociacaoTitulos,
      quantidadeParcelas: value?.parcelas,
    });
    setCondicaoPagamento(value);
  };

  return (
    <>
      {renderRenegociacaoTitulos && (
        <div
          className="p-3 position-fixed bottom-0 bg-white d-flex flex-row flex-wrap"
          style={{
            width: openCollapse ? "calc(100vw - 338px)" : "calc(100vw - 128px)",
            transition: "width 400ms ease",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Autocomplete
                id="meioPagamentoRenegociacao"
                name="meioPagamentoRenegociacao"
                required
                options={listaMeiosPagamento}
                autoHighlight
                getOptionLabel={(option) =>
                  option.descricao ? option.descricao : ""
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Meio de Pagamento"
                    variant="outlined"
                    margin="normal"
                    required
                    error={inputErros.get("meioPagamentoRenegociacao")}
                  />
                )}
                onChange={(_, newValue) => onChangeMeioPagamento(newValue)}
                value={meioPagamento}
              />
            </Grid>
            <Grid item xs={3}>
              <Autocomplete
                required
                id="condicaoPagamentoRenegociacao"
                name="condicaoPagamentoRenegociacao"
                options={listaMeiosCondicao}
                autoHighlight
                getOptionLabel={(option) =>
                  option.descricao ? option.descricao : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                disableClearable
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Condição de Pagamento"
                    variant="outlined"
                    margin="normal"
                    required
                    error={inputErros.get("condicaoPagamentoRenegociacao")}
                  />
                )}
                onChange={(_, newValue) => onChangeCondicao(newValue)}
                value={condicaoPagamento}
              />
            </Grid>
            <Grid item xs={3}>
              <DatePicker
                id="dataVencimento"
                name="dataVencimento"
                label="Data de Vencimento"
                format="dd/MM/yyyy"
                variant="outlined"
                margin
                required
                error={inputErro.indexOf("dataPagamento") != -1 ? true : false}
                fullWidth
                value={
                  renegociacaoTitulos?.dataVencimento
                    ? renegociacaoTitulos.dataVencimento
                    : null
                }
                onChange={(date) => onDateChange(date, "dataVencimento")}
              />
            </Grid>
            <Grid item xs={3}>
              <Button
                id="baixarTitulos"
                name="baixarTitulos"
                variant="contained"
                color="success"
                sx={{ p: "0.9rem", mt: "1rem" }}
                disabled={
                  !meioPagamento ||
                  !condicaoPagamento ||
                  !renegociacaoTitulos?.dataVencimento
                }
                onClick={handleOpenRenegociacao}
                fullWidth
              >
                <i
                  className="ph-fill ph-currency-dollar"
                  style={{ fontSize: 22, marginRight: 10, color: "white" }}
                ></i>
                Renegociar
              </Button>
            </Grid>
          </Grid>
          <RenegociacaoTitulosDialog
            openDialogRenegociacao={openDialogRenegociacao}
            setOpenDialogRenegociacao={setOpenDialogRenegociacao}
            listaRenegociacoes={listaRenegociacoes}
            setListaRenegociacoes={setListaRenegociacoes}
            handleSubmit={handleSubmit}
            sairRenegociacaoTitulos={sairRenegociacaoTitulos}
            listaMeiosPagamento={listaMeiosPagamento}
            pagadoresIguais={pagadoresIguais}
            pagadorList={pagadorList}
            pagadorId={pagadorId}
            setPagadorId={setPagadorId}
          />
          <AddInfoBoletoDialog
            open={openDialogInfoBoleto}
            setOpen={setOpenDialogInfoBoleto}
            cliente={cliente}
            contaBancaria={contaBancaria}
            enderecos={enderecos}
            convenios={convenios}
            contasReceber={contasReceber}
            gerarBoletos={gerarBoletos}
            setLoading={setLoading}
          />
          <ResumoTotalContas totalAReceber={totalAReceber} />
        </div>
      )}
    </>
  );
};

export default RenegociacaoTitulos;
